import sectorIndepthOverview from './overview';
import sectorIndepthCommon from './common';
import sectorIndepthPerformance from './performance';
import sectorIndepthProportion from './proportion';
import sectorIndepthFmi from './fmi';
import sectorIndepthInvestor from './investor';
export default {
  sectorIndepthCommon,
  sectorIndepthOverview,
  sectorIndepthPerformance,
  sectorIndepthProportion,
  sectorIndepthFmi,
  sectorIndepthInvestor,
};
